import TAnnouncementsAdd from './index.vue';

TAnnouncementsAdd.install = app => {
  app.component(TAnnouncementsAdd.name, TAnnouncementsAdd);
};

export default TAnnouncementsAdd;
